const compatModules = {};import * as Mod1 from "./discourse/components/waze-wiki-badge";
compatModules["discourse/components/waze-wiki-badge"] = Mod1;

export * as discourse$components$waze__wiki__badge$$__module from "./discourse/components/waze-wiki-badge";
export {
default as discourse$components$waze__wiki__badge$$default
} from "./discourse/components/waze-wiki-badge";
import * as Mod2 from "./discourse/components/waze-wiki-post-header";
compatModules["discourse/components/waze-wiki-post-header"] = Mod2;

export * as discourse$components$waze__wiki__post__header$$__module from "./discourse/components/waze-wiki-post-header";
export {
default as discourse$components$waze__wiki__post__header$$default
} from "./discourse/components/waze-wiki-post-header";
import * as Mod3 from "./discourse/connectors/post-meta-data-poster-name/waze-wiki-post-header.gjs";
compatModules["discourse/connectors/post-meta-data-poster-name/waze-wiki-post-header"] = Mod3;

export * as discourse$connectors$post__meta__data__poster__name$waze__wiki__post__header$$__module from "./discourse/connectors/post-meta-data-poster-name/waze-wiki-post-header.gjs";
export {
default as discourse$connectors$post__meta__data__poster__name$waze__wiki__post__header$$default
} from "./discourse/connectors/post-meta-data-poster-name/waze-wiki-post-header.gjs";
import * as Mod4 from "./discourse/connectors/search-menu-results-topic-title-suffix/waze-wiki-badge.gjs";
compatModules["discourse/connectors/search-menu-results-topic-title-suffix/waze-wiki-badge"] = Mod4;

export * as discourse$connectors$search__menu__results__topic__title__suffix$waze__wiki__badge$$__module from "./discourse/connectors/search-menu-results-topic-title-suffix/waze-wiki-badge.gjs";
export {
default as discourse$connectors$search__menu__results__topic__title__suffix$waze__wiki__badge$$default
} from "./discourse/connectors/search-menu-results-topic-title-suffix/waze-wiki-badge.gjs";
import * as Mod5 from "./discourse/connectors/search-results-topic-title-suffix/waze-wiki-badge.gjs";
compatModules["discourse/connectors/search-results-topic-title-suffix/waze-wiki-badge"] = Mod5;

export * as discourse$connectors$search__results__topic__title__suffix$waze__wiki__badge$$__module from "./discourse/connectors/search-results-topic-title-suffix/waze-wiki-badge.gjs";
export {
default as discourse$connectors$search__results__topic__title__suffix$waze__wiki__badge$$default
} from "./discourse/connectors/search-results-topic-title-suffix/waze-wiki-badge.gjs";
import * as Mod6 from "./discourse/connectors/topic-above-post-stream/waze-wiki-badge.gjs";
compatModules["discourse/connectors/topic-above-post-stream/waze-wiki-badge"] = Mod6;

export * as discourse$connectors$topic__above__post__stream$waze__wiki__badge$$__module from "./discourse/connectors/topic-above-post-stream/waze-wiki-badge.gjs";
export {
default as discourse$connectors$topic__above__post__stream$waze__wiki__badge$$default
} from "./discourse/connectors/topic-above-post-stream/waze-wiki-badge.gjs";
import * as Mod7 from "./initializers/waze-wiki-initializer";
compatModules["initializers/waze-wiki-initializer"] = Mod7;

export * as initializers$waze__wiki__initializer$$__module from "./initializers/waze-wiki-initializer";
export {
default as initializers$waze__wiki__initializer$$default
} from "./initializers/waze-wiki-initializer";
export default compatModules;
